export default {
  viewBox: "0 0 25 24",
  paths: [
    "M16.6567 17.8267L15.6565 18.8101L9.17407 12.1389L15.6565 5.18994L16.6567 6.16089L11.0045 12.1389L16.6567 17.8267Z"
  ]
};